import { render, staticRenderFns } from "./Setpermi.vue?vue&type=template&id=1d4d8fd8&scoped=true"
import script from "./Setpermi.vue?vue&type=script&lang=js"
export * from "./Setpermi.vue?vue&type=script&lang=js"
import style0 from "./Setpermi.vue?vue&type=style&index=0&id=1d4d8fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d8fd8",
  null
  
)

export default component.exports